import { UserManagerService } from './../../services/user-manager/user-manager.service';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-dashboard-item',
  templateUrl: './dashboard-item.component.html',
  styleUrls: ['./dashboard-item.component.scss']
})
export class DashboardItemComponent implements OnInit {
  @Input() value: number;
  @Input() title: any;
  @Input() icon: string;
  @Input() clickable: boolean;
  @Input() privilege: string;
  @Input() groupOrder: number;
  @Input() iconPath: string;
  hover = false;
  itemBgLs = [
    '#AF1763', // 0 Magenta Rose
    '#AB2E3C', // 1 Crimson Red
    '#0D6EFD', // 2 Primary Blue
    '#198754', // 3 Success Green
    '#0DCAF0', // 4 Cyan
    '#FFC107', // 5 Amber
    '#FF4747', // 6 Alert Red
    '#9E58FF', // 7 Purple

    '#FE9496', // 8 Soft Coral
    '#17A2B8', // 9 Teal Blue
    '#00CCCC', // 10 Aqua
    '#6F42C1', // 11 Indigo Purple
    '#38CE3C', // 12 Bright Green
  ];

  itemBorderGradientLs = [
    'rgba(135, 14, 75, 1)',  // 0 Deep Magenta (for #AF1763)
    'rgba(130, 34, 45, 1)',  // 1 Dark Crimson (for #AB2E3C)
    'rgba(10, 88, 202, 1)',  // 2 Deep Blue (for #0D6EFD)
    'rgba(20, 108, 67, 1)',  // 3 Forest Green (for #198754)
    'rgba(9, 160, 190, 1)',  // 4 Deep Cyan (for #0DCAF0)
    'rgba(204, 154, 0, 1)',  // 5 Dark Amber (for #FFC107)
    'rgba(204, 40, 40, 1)',  // 6 Deep Alert Red (for #FF4747)
    'rgba(126, 70, 215, 1)', // 7 Deep Purple (for #9E58FF)

    'rgba(220, 110, 112, 1)', // 8 Muted Coral Red (for #FE9496)
    'rgba(18, 135, 155, 1)',  // 9 Deep Teal (for #17A2B8)
    'rgba(0, 150, 150, 1)',   // 10 Deep Aqua (for #00CCCC)
    'rgba(88, 52, 155, 1)',   // 11 Indigo Shadow (for #6F42C1)
    'rgba(40, 170, 45, 1)',   // 12 Deep Green (for #38CE3C)
  ];
  constructor(public userService:UserManagerService) { }

  get bgColor() {
    return this.itemBgLs[this.groupOrder]
  }

  get color() {
    return this.itemBorderGradientLs[this.groupOrder]
  }

  ngOnInit() {
  }

}
